export const PROJECT_STATUSES = [
  "new",
  "design",
  "in_progress",
  "quote",
  "contract",
  "completed",
] as const;

export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  new: "Новий",
  design: "Проектування",
  in_progress: "В роботі",
  quote: "КП",
  contract: "Договір",
  completed: "Реалізовано",
};

export interface Project {
  id: string;
  project_code: string | null;
  owner_id: string;
  manager_id: string | null;
  name: string;
  client_name: string | null;
  client_phone: string | null;
  region: string | null;
  address: string | null;
  description: string | null;
  area_m2: number | null;
  status: ProjectStatus;
  contract_amount: number | null;
  bonus_amount: number | null;
  manager_comment: string | null;
  submitted_at: string;
  closed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface ProjectStageValue {
  id: number;
  project_id: string;
  status: ProjectStatus | null;
  contract_amount: number | null;
  bonus_amount: number | null;
  manager_comment: string | null;
  updated_at: string;
}

export interface ProjectFile {
  id: string;
  project_id: string;
  uploaded_by: string | null;
  bucket: string;
  storage_path: string;
  file_name: string;
  mime_type: string | null;
  size_bytes: number | null;
  created_at: string;
}